module.exports = __webpack_public_path__ + "img/about-patent7.298b8ec.png";